'use client';

import Image from 'next/image';
import { type JSX } from 'react';

import { DotSpinner } from '../../../_shared/_components/DotSpinner/DotSpinner';
import { AI_TOOLKIT_MAIN_PANEL_IMAGE_SIZES } from '../../_layouts/AiToolkitMainPanel';

function GlowBackground(): JSX.Element {
    return <div aria-hidden="true" className="absolute -inset-2 rounded-sm blur animate-glow-rotate glow-background" />;
}

type LoadingCardProps = {
    thumbnailUrl?: string;
    thumbnailAlt?: string;
};

export function LoadingCard({ thumbnailUrl, thumbnailAlt = '' }: LoadingCardProps): JSX.Element {
    return (
        <div className="relative w-full">
            <GlowBackground />
            <div className="relative z-10 aspect-video rounded-sm bg-black overflow-hidden">
                {thumbnailUrl && (
                    <div className="absolute inset-0">
                        <Image
                            src={thumbnailUrl}
                            alt={thumbnailAlt}
                            fill
                            sizes={AI_TOOLKIT_MAIN_PANEL_IMAGE_SIZES}
                            className="object-contain"
                        />
                        <div
                            className="pointer-events-none absolute inset-0 rounded-[inherit] inset-ring-1 inset-ring-white/20"
                            data-testid="playback-card-ring"
                        />
                    </div>
                )}
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                    <DotSpinner size="large" />
                </div>
            </div>
        </div>
    );
}
